/*
 * Usage: set "focusInput=true" inside an event like ng-click or on-change, then set the below syntax correctly on the target element.
 * syntax: <input oly-grab-focus="focusInput" />
 * target: the element where oly-grab-focus is specified.
 *
 * example 1: The following will grab focus on the target element after the initiator changes
 *
 *          <oly-inline-dropdown on-change="focusInput=true" class="checkoutPayment-methodsDropdown"></oly-inline-dropdown> //initiate
 *
 *          <input type="checkbox" oly-grab-focus="focusInput" /> //target
 *
 *
 */

module.exports = function ($timeout) {
    return function (scope, elem, attrs) {
        const expression = attrs.olyGrabFocus;
        scope.$watch(expression, function (value) {
            if (value) {
                $timeout(function () {
                    elem.focus();
                });
            }
        });
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/grabfocus/grabfocus-directive.js
 **/